// extracted by mini-css-extract-plugin
export default {"pill":"Compliance_pill__z-OD6","compliant":"Compliance_compliant__W+sd4"};